// extracted by mini-css-extract-plugin
export default {"container":"WordGameLayout_container__7DuaP","sub_container":"WordGameLayout_sub_container__OSumP"};